"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $dyn;
(function ($dyn) {
    Globalize.addCultureInfo("en", {
        messages: {
            TaskGuidesStep_ConfirmInfoStep: "Got it",
            TaskGuidesStep_RailsSwitchAckMsg: "Click here if you wish to unlock access to all controls",
            TaskGuidesStep_RailsSwitchAckNote: "You can lock or unlock access to all controls using this switch at any step during task guide.",
            TaskGuidesStep_ShowLess: "Show less",
            TaskGuidesStep_ShowMore: "Show more",
        }
    });
    var ax;
    (function (ax) {
        var taskRecorder;
        (function (taskRecorder) {
            var ActionType;
            (function (ActionType) {
                ActionType["Info"] = "Info";
                ActionType["None"] = "";
            })(ActionType = taskRecorder.ActionType || (taskRecorder.ActionType = {}));
            /**
             * The controller of the Task Guides whose main responsibility is the proper positioning of the tooltip at the right place with the right content.
             * Also initializes and consumes the component chain output.
             */
            var Controller = /** @class */ (function () {
                function Controller() {
                    var _this = this;
                    this.ToggleDetails = function () {
                        var currentVisibility = $dyn.value(_this.DetailsGroupVisibilityToggled);
                        _this.DetailsGroupVisibilityToggled(!currentVisibility);
                        _this.qtip.reposition();
                        _this.showHideTip();
                    };
                    this.ToggleGuidedStep = function () {
                        var currentVisibility = $dyn.value(_this.GuidedStepVisible);
                        _this.GuidedStepVisible(!currentVisibility);
                        _this.qtip.reposition();
                        _this.showHideTip();
                    };
                    this.SkipBackGuidedStep = function () {
                        _this.showHideOnTransition(true);
                        _this.skipBackGuidedStepTrigger($dyn.peek(_this.skipBackGuidedStepTrigger) + 1);
                    };
                    this.SkipGuidedStep = function () {
                        _this.showHideOnTransition(true);
                        _this.skipGuidedStepTrigger($dyn.peek(_this.skipGuidedStepTrigger) + 1);
                    };
                    this.onContinueTaskGuideClicked = function () {
                        _this.clearRailsSwitchAck();
                        if (_this.chainOutput) {
                            _this.updateQTip($dyn.value(_this.chainOutput.output));
                        }
                    };
                    /** Update the position of the QTip. */
                    this.updateQTip = function (guidedStepModel) {
                        var tipDefault = {
                            height: 12,
                            width: 26
                        };
                        var adjustDefault = {
                            method: "flipinvert",
                            // We are handling resize and scroll events by ourself
                            resize: false,
                            scroll: false,
                            x: 0,
                            y: 0
                        };
                        if (!guidedStepModel) {
                            return;
                        }
                        // Reject deferreds and unsubscribe from observables to cancel previous update
                        if (_this.clientIsNotBusy) {
                            _this.clientIsNotBusy.reject();
                        }
                        if (_this.clientBusySubscription) {
                            _this.clientBusySubscription.dispose && _this.clientBusySubscription.dispose();
                            _this.clientBusySubscription = undefined;
                        }
                        var options = guidedStepModel.options;
                        var content = guidedStepModel.content;
                        // Unsubscribe and cancel deferreds here
                        _this.clientIsNotBusy = $.Deferred();
                        _this.clientBusySubscription = $dyn.observe(function () {
                            return !$dyn.value($dyn.clientBusy) && !$dyn.value(_this.serverUpdatePending) && ($dyn.value(_this.pendingTimeOut) <= 0);
                        }, function (value) {
                            if (value) {
                                _this.clientIsNotBusy && _this.clientIsNotBusy.resolve();
                                return false;
                            }
                        });
                        $.when(_this.clientIsNotBusy).done(function () {
                            // If this.clientIsNotBusy is null then qTip is already proccessed and should not re process
                            // In case this is called after the task recorder has stopped, don't process the qtip logic
                            if (_this.clientIsNotBusy === null || $dyn.value($dyn.ax.taskRecording.taskRecorderStateControl.TaskGuidePlaybackState) === false) {
                                return;
                            }
                            _this._ignorePostponedCallbacks = true;
                            if ($dyn.value(_this.GuidedStep)) {
                                if ($dyn.value(_this.GuidedStep).action === ActionType.Info) {
                                    _this.ActionType(ActionType.Info);
                                }
                                else {
                                    // any is used because we do not know what different strings can come from server
                                    // We only know about type Info
                                    _this.ActionType($dyn.value(_this.GuidedStep).action);
                                }
                            }
                            if (content) {
                                _this.Title(content.Title);
                                _this.Header(content.Header ? content.Header : "");
                                _this.Image(content.Image);
                                _this.Example(content.Example);
                                _this.Note(content.Note);
                                _this.Step(content.Step);
                                _this.GuidedStepVisible(true);
                                _this.BackButtonVisible(content.allowBack !== false);
                                _this.NextButtonVisible(content.allowNext !== false && !$dyn.value(_this.ConfirmInfoStepVisible));
                                if (content.ConfirmInfoStepText) {
                                    _this.ConfirmInfoStepText(content.ConfirmInfoStepText);
                                }
                                else {
                                    _this.ConfirmInfoStepText($dyn.label("TaskGuidesStep_ConfirmInfoStep"));
                                }
                                _this.ShowMinimizeButton(content.HideMinimizeButton !== true);
                            }
                            if (options) {
                                var target_1 = options.target;
                                if (options.shadowTarget && options.shadowTarget[0]) {
                                    target_1 = options.shadowTarget;
                                }
                                if (!_this.qtip) {
                                    // Setting qtipCreated explicitly to false as we know with certainity that the qtip doesn't exist and the value may be stale from a previous run.
                                    _this.qtipCreated(false);
                                    var qtipStyle = "taskGuide-popup binding-focusRegion taskGuide-ignoreObscurityError baseDirection";
                                    if (options.styles && options.styles.classes) {
                                        _this.lastAppliedClasses = options.styles.classes;
                                        qtipStyle = qtipStyle + " " + _this.lastAppliedClasses;
                                    }
                                    _this.qtip = $(document.body).qtip({
                                        content: {
                                            text: $(_this.contentPlaceholder)
                                        },
                                        hide: "false",
                                        position: {
                                            adjust: {
                                                method: options.adjustMethod || "flip",
                                                resize: options.adjust && options.adjust.resize || false,
                                                scroll: options.adjust && options.adjust.scroll || false,
                                                x: options.adjust && options.adjust.x || 0,
                                                y: options.adjust && options.adjust.y || 0
                                            },
                                            at: options.at || $dyn.layout.qTipPosition.rightCenter,
                                            effect: function (api, pos, viewport) {
                                                _this._forceHideTip = undefined;
                                                if (pos) {
                                                    var qtipWidth = _this.qtip.elements.tooltip.width();
                                                    var qtipHeight = _this.qtip.elements.tooltip.height();
                                                    if (pos.left < 0 || (pos.left + qtipWidth > $(window).width()) || pos.top < 0 || (pos.top + qtipHeight > $(window).height())) {
                                                        var stackContainer = $("#" + $dyn.shell.stackContainerId);
                                                        pos.left = stackContainer.offset().left + stackContainer.width() - qtipWidth - 10;
                                                        pos.top = stackContainer.offset().top + 10;
                                                        _this._forceHideTip = true;
                                                    }
                                                }
                                                _this.qtip.elements.tooltip.animate(pos, {
                                                    duration: $dyn.flags.disableAnimations ? 0 : 400,
                                                    easing: "swing",
                                                    queue: false
                                                });
                                            },
                                            my: options.my || $dyn.layout.qTipPosition.rightCenter,
                                            target: target_1,
                                            viewport: $(window),
                                        },
                                        style: {
                                            classes: qtipStyle,
                                            tip: tipDefault
                                        }
                                    }).qtip("api");
                                    // Wait a bit before showing the tip to accomodate animations and layout changes
                                    window.setTimeout(function () {
                                        _this.qtip.show();
                                        _this.showHideTip(options);
                                        _this.qtipCreated(true);
                                    }, $dyn.flags.disableAnimations ? 0 : 400);
                                }
                                else {
                                    var updateQTipPosition_1 = function () {
                                        // Handle applying external classes to the qtip based on task guide params
                                        // This is done before repositionig so that correct dimensions are applied
                                        if (_this.lastAppliedClasses) {
                                            _this.qtip.elements.tooltip.removeClass(_this.lastAppliedClasses);
                                            _this.lastAppliedClasses = undefined;
                                        }
                                        if (options.styles && options.styles.classes) {
                                            _this.lastAppliedClasses = options.styles.classes;
                                            _this.qtip.elements.tooltip.addClass(_this.lastAppliedClasses);
                                        }
                                        // Convert options to qtip position
                                        // type any is used for merging newPosition with adjust and adjustDefault and also for sending to qtip.set
                                        var newPosition = {
                                            "position.at": options.at,
                                            "position.my": options.my,
                                            "position.target": target_1
                                        };
                                        $.each($.extend({}, adjustDefault, { method: options.adjustMethod }, options.adjust), function (key, value) {
                                            newPosition["position.adjust." + key] = value;
                                        });
                                        _this.qtip.set(newPosition);
                                        // Bring the qtip to the front of all qtips.
                                        // Needed for qtips on top of personalization qtip.
                                        _this.qtip.focus();
                                        _this.showHideTip(options);
                                    };
                                    if ($dyn.peek(_this.qtipCreated) === false) {
                                        $dyn.observe(_this.qtipCreated, function () {
                                            if ($dyn.peek(_this.qtipCreated) === true) {
                                                updateQTipPosition_1();
                                                return false;
                                            }
                                        });
                                    }
                                    else {
                                        updateQTipPosition_1();
                                    }
                                }
                            }
                            _this._ignorePostponedCallbacks = false;
                            _this.clientIsNotBusy = null;
                        });
                    };
                    this.GuidedStep = null;
                    this.qtip = null;
                    this.tipHidden = false;
                    this.tipWidth = 26;
                    this.Title = $dyn.observable("");
                    this.Header = $dyn.observable("");
                    this.Image = $dyn.observable();
                    this.Example = $dyn.observable("");
                    this.Note = $dyn.observable("");
                    this.Step = $dyn.observable("");
                    this.ActionType = $dyn.observable(ActionType.None);
                    this.ConfirmInfoStepText = $dyn.observable("");
                    this.DetailsGroupVisibilityToggled = $dyn.observable(false);
                    this.GuidedStepVisible = $dyn.observable(true);
                    this.serverUpdatePending = $dyn.observable(false);
                    this.RailsSwitchAckVisible = $dyn.observable(false);
                    this.NextButtonVisible = $dyn.observable(false);
                    this.BackButtonVisible = $dyn.observable(false);
                    this.skipBackGuidedStepTrigger = $dyn.observable(0);
                    this.skipGuidedStepTrigger = $dyn.observable(0);
                    this.pendingTimeOut = $dyn.observable(0);
                    this._ignorePostponedCallbacks = false;
                    this.qtipCreated = $dyn.observable(false);
                    this.clientIsNotBusy = null;
                    this.clientBusySubscription = null;
                    this.ShowMinimizeButton = $dyn.observable(true);
                    this.componentsDisposal = null;
                    this.subscriptions = [];
                    this.GuidedStepCollapsed = $dyn.computed(function () {
                        return !_this.GuidedStepVisible();
                    });
                    this.TitleVisible = $dyn.computed(function () {
                        return _this.Title() !== "";
                    });
                    this.HeaderVisible = $dyn.computed(function () {
                        return _this.Header() !== "";
                    });
                    this.ImageVisible = $dyn.computed(function () {
                        return _this.Image() !== undefined && _this.Image() !== null;
                    });
                    this.StepVisible = $dyn.computed(function () {
                        return _this.Step() !== "";
                    });
                    this.StepAndTitleVisible = $dyn.computed(function () {
                        return _this.StepVisible() && _this.TitleVisible();
                    });
                    this.ExampleGroupVisible = $dyn.computed(function () {
                        return $dyn.value(_this.Example) !== "";
                    });
                    this.NoteGroupVisible = $dyn.computed(function () {
                        return $dyn.value(_this.Note) !== "";
                    });
                    this.ConfirmInfoStepVisible = $dyn.computed(function () {
                        return ($dyn.value(_this.ActionType) === $dyn.ax.taskRecorder.ActionType.Info) && !$dyn.value(_this.RailsSwitchAckVisible);
                    });
                    this.DetailsGroupVisible = $dyn.computed(function () {
                        return $dyn.value(_this.DetailsGroupVisibilityToggled);
                    });
                    this.DetailsButtonTitle = $dyn.computed(function () {
                        return $dyn.value(_this.DetailsGroupVisible) ? $dyn.label("TaskGuidesStep_ShowLess") : $dyn.label("TaskGuidesStep_ShowMore");
                    });
                    this.DetailsButtonSymbol = $dyn.computed(function () {
                        return $dyn.value(_this.DetailsButtonTitle) !== undefined && $dyn.value(_this.DetailsGroupVisible) ? "ChevronUp" : "ChevronDown";
                    });
                    $dyn.observe(this.serverUpdatePending, function (value) {
                        _this.showHideOnTransition(value);
                    });
                }
                Controller.prototype.addSubscription = function (subscription) {
                    this.subscriptions.push(subscription);
                };
                Controller.prototype.setComponentsDisposal = function (value) {
                    this.componentsDisposal = value;
                };
                Controller.prototype.initPlaceholder = function () {
                    this.contentPlaceholder = document.createElement("div");
                    this.contentPlaceholder.setAttribute("data-dyn-template", "templateId: 'TaskGuideStep'");
                    $dyn.dataBind(this.contentPlaceholder, new $dyn.DataContext(this));
                };
                /**
                 * Given an array of components, chains their inputs and outputs.
                 * Two components are in chain when one component is able to raise a change on its output object
                 * and another component is listening to a change of the first component. Chaining is done by passing output of
                 * one component as input of another.
                 */
                Controller.prototype.chainComponents = function (input, components) {
                    var e_1, _a;
                    var currentInput = input;
                    var disposals = [];
                    try {
                        for (var components_1 = __values(components), components_1_1 = components_1.next(); !components_1_1.done; components_1_1 = components_1.next()) {
                            var component = components_1_1.value;
                            var currentOutput = $dyn.observable();
                            component.setup(currentInput, currentOutput);
                            disposals.push(component.dispose);
                            currentInput = currentOutput;
                        }
                    }
                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
                    finally {
                        try {
                            if (components_1_1 && !components_1_1.done && (_a = components_1.return)) _a.call(components_1);
                        }
                        finally { if (e_1) throw e_1.error; }
                    }
                    /**
                     * @prop output The output of the last component.
                     * @prop dispose Calls the dispose methods for components in the component chain.
                     */
                    return {
                        dispose: function () {
                            var e_2, _a;
                            try {
                                // Dispose in the opposite order
                                for (var disposals_1 = __values(disposals), disposals_1_1 = disposals_1.next(); !disposals_1_1.done; disposals_1_1 = disposals_1.next()) {
                                    var disposal = disposals_1_1.value;
                                    if (disposal) {
                                        disposal();
                                    }
                                }
                            }
                            catch (e_2_1) { e_2 = { error: e_2_1 }; }
                            finally {
                                try {
                                    if (disposals_1_1 && !disposals_1_1.done && (_a = disposals_1.return)) _a.call(disposals_1);
                                }
                                finally { if (e_2) throw e_2.error; }
                            }
                        },
                        output: currentInput
                    };
                };
                Controller.prototype.setTimeout = function (callback, timeout, args) {
                    var _this = this;
                    if (this._ignorePostponedCallbacks) {
                        return;
                    }
                    if (this.testFlag) {
                        callback.apply(null, args);
                        return;
                    }
                    this.pendingTimeOut(($dyn.peek(this.pendingTimeOut) + 1));
                    return window.setTimeout(function () {
                        _this.pendingTimeOut(($dyn.peek(_this.pendingTimeOut) - 1));
                        callback.apply(null, args);
                    }, timeout);
                };
                Controller.prototype.clearTimeout = function (timeoutHandle) {
                    if (this._ignorePostponedCallbacks || this.testFlag) {
                        return;
                    }
                    this.pendingTimeOut(($dyn.peek(this.pendingTimeOut) - 1));
                    window.clearTimeout(timeoutHandle);
                };
                /** Alternately vibrate the QTip and dispose the rails blocks. */
                Controller.prototype.onRailsBlocksClicked = function () {
                    var _this = this;
                    var railsBlocksClickCounter = 0;
                    if ($dyn.value($dyn.clientBusy) || $dyn.value(this.serverUpdatePending) || ($dyn.value(this.pendingTimeOut) > 0)) {
                        return;
                    }
                    if ($dyn.value(this.RailsSwitchAckVisible)) {
                        return;
                    }
                    var $unlockIcon = $("#railsModeUnlock");
                    if ((railsBlocksClickCounter % 2) === 0) {
                        var guidedStepOptions = {
                            action: "",
                            adjustMethod: "flip",
                            at: $dyn.layout.qTipPosition.bottomCenter,
                            my: $dyn.layout.qTipPosition.topCenter,
                            target: $unlockIcon
                        };
                        var guidedStepContentModel = {
                            allowBack: false,
                            allowNext: false,
                            Note: $dyn.label("TaskGuidesStep_RailsSwitchAckNote"),
                            Step: $dyn.label("TaskGuidesStep_RailsSwitchAckMsg"),
                        };
                        this.updateQTip({ content: guidedStepContentModel, options: guidedStepOptions });
                        var railsModeSwitchObserver_1 = $dyn.observe($dyn.ax.taskRecording.taskGuideRailsMode, function (railMode) {
                            if (!railMode && _this && $dyn.value(_this.RailsSwitchAckVisible)) {
                                _this.clearRailsSwitchAck();
                                if (_this.chainOutput) {
                                    _this.updateQTip($dyn.value(_this.chainOutput.output));
                                }
                            }
                        });
                        var outputObserver_1 = $dyn.observe(this.chainOutput.output, function () {
                            if ($dyn.value(_this.RailsSwitchAckVisible)) {
                                _this.clearRailsSwitchAck();
                            }
                        });
                        this.clearRailsSwitchAck = function () {
                            if (railsModeSwitchObserver_1) {
                                railsModeSwitchObserver_1.dispose();
                                railsModeSwitchObserver_1 = undefined;
                            }
                            if (outputObserver_1) {
                                outputObserver_1.dispose();
                                outputObserver_1 = undefined;
                            }
                            _this.RailsSwitchAckVisible(false);
                        };
                        this.RailsSwitchAckVisible(true);
                    }
                    else {
                        // vibrate qtip
                        $(document.body).addClass("taskGuide-animate");
                        window.setTimeout(function () {
                            $(document.body).removeClass("taskGuide-animate");
                        }, 100);
                    }
                    railsBlocksClickCounter++;
                };
                Controller.prototype.disposeTaskGuide = function () {
                    if (this.componentsDisposal) {
                        if (this.subscriptions) {
                            for (var i in this.subscriptions) {
                                if (this.subscriptions[i] && this.subscriptions[i].dispose) {
                                    this.subscriptions[i].dispose();
                                }
                            }
                        }
                        this.componentsDisposal();
                        this.disposeQTip();
                    }
                    this._forceHideTip = undefined;
                };
                /** Initializes the Task Guide and its component chain. */
                Controller.prototype.initTaskGuide = function (testFlag) {
                    this.testFlag = testFlag;
                    if (!this.testFlag) {
                        this.initPlaceholder();
                    }
                    this.controlComponent = new $dyn.ax.taskGuide.ControlComponent(this);
                    this.scrollComponent = new $dyn.ax.taskGuide.ScrollComponent(this);
                    this.qtipComponent = new $dyn.ax.taskGuide.QTipComponent(this);
                    this.railsModeComponent = new $dyn.ax.taskGuide.RailsModeComponent(this);
                    this.layoutUpdateHandlingComponent = new $dyn.ax.taskGuide.LayoutUpdateHandlingComponent(this);
                    this.chainOutput = this.chainComponents(this.GuidedStep, [this.controlComponent, this.scrollComponent,
                        this.layoutUpdateHandlingComponent, this.railsModeComponent, this.qtipComponent]);
                    this.setComponentsDisposal(this.chainOutput.dispose);
                    if (!this.testFlag) {
                        this.addSubscription($dyn.observe(this.chainOutput.output, this.updateQTip));
                    }
                    return $dyn.value(this.chainOutput.output);
                };
                Controller.prototype.showHideTip = function (options) {
                    var hide = this._forceHideTip;
                    if (hide === undefined) {
                        hide = options && options.styles && options.styles.hideTip;
                    }
                    if (hide) {
                        this.qtip.elements.tip.css("visibility", "hidden");
                    }
                    else {
                        this.qtip.elements.tip.css("visibility", "");
                    }
                };
                /**
                 * Apply a transtioning style when the server update is pending.
                 * Not tracking for disposal as there is no controller dispose lifecylce as a global singleton.
                 */
                Controller.prototype.showHideOnTransition = function (show) {
                    var _this = this;
                    var removeTransition;
                    if (this.qtip) {
                        if (show) {
                            this.qtip.elements.tooltip.addClass("on-transition");
                            removeTransition = false;
                        }
                        else {
                            if (!removeTransition) {
                                removeTransition = true;
                                window.setTimeout(function () {
                                    if (removeTransition) {
                                        _this.qtip.elements.tooltip.removeClass("on-transition");
                                        removeTransition = false;
                                    }
                                }, $dyn.flags.disableAnimations ? 0 : 400);
                            }
                        }
                    }
                };
                Controller.prototype.disposeQTip = function () {
                    if (this.qtip) {
                        if (this.qtip.options && this.qtip.options.content && this.qtip.options.content.text && this.qtip.options.content.text.length > 0) {
                            var qtipElement = this.qtip.options.content.text[0];
                            $dyn.unbind(qtipElement);
                        }
                        this.qtip.destroy(true);
                        this.qtip = null;
                        this.NextButtonVisible.valueChanged.clear();
                        this.BackButtonVisible.valueChanged.clear();
                    }
                };
                return Controller;
            }());
            taskRecorder.Controller = Controller;
        })(taskRecorder = ax.taskRecorder || (ax.taskRecorder = {}));
    })(ax = $dyn.ax || ($dyn.ax = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=Controller.js.map
